class ColorHandler {
	constructor() {
		this.prevActiveInstance = null;
		this.items = Array.from(document.querySelectorAll("[data-section]"));
		this.init();
	}

	init() {
		this.setDefaults();
		this.createInstances();
		this.handleScroll();
		window.addEventListener("scroll", this.handleScroll.bind(this), { passive: true });
	}

	setDefaults() {
		const styles = window.getComputedStyle(document.documentElement);
		this.defaultColors = {
			sectionBackground: styles.getPropertyValue("--section_background")?.trim(),
			sectionForeground: styles.getPropertyValue("--section_foreground")?.trim(),
			headerBackground: styles.getPropertyValue("--header-background")?.trim(),
			headerForeground: styles.getPropertyValue("--header-foreground")?.trim()
		};
	}

	createInstances() {
		this.instances = this.items.map((el) => {
			try {
				const settings = JSON.parse(el.innerHTML);
				const parent = el.parentNode;
				if (!parent || !parent.getBoundingClientRect) throw new Error("Invalid parent");
				return {
					element: parent,
					settings
				};
			} catch (e) {
				console.warn("Fejl i data-section:", e);
				return null;
			}
		}).filter(Boolean);
	}

	getActiveInstance() {
	const buffer = 50;
	const middle = window.innerHeight / 2;
	const active = this.instances.find(instance => {
		const rect = instance.element.getBoundingClientRect();
		return rect.top <= middle + buffer && rect.bottom >= middle - buffer;
	});

	// Hvis ingen aktiv, find nærmeste sektion der IKKE er footer
	if (!active) {
		let closest = null;
		let minDistance = Infinity;

		this.instances.forEach(instance => {
			if (instance.element.closest("footer")) return; // Skip footer
			const rect = instance.element.getBoundingClientRect();
			const sectionMiddle = rect.top + rect.height / 2;
			const distance = Math.abs(middle - sectionMiddle);
			if (distance < minDistance) {
				minDistance = distance;
				closest = instance;
			}
		});

		return closest || null;
	}

	return active;
}

	handleScroll() {
		const activeInstance = this.getActiveInstance();

		// Brug default hvis ingen aktiv sektion findes
		const {
			sectionBackground,
			sectionForeground,
			headerBackground,
			headerForeground
		} = {
			...this.defaultColors,
			...(activeInstance?.settings || {})
		};

		// Undgå dobbeltopsætning
		if (this.prevActiveInstance === activeInstance && activeInstance !== null) return;

		document.documentElement.style.setProperty("--section_background", sectionBackground);
		document.documentElement.style.setProperty("--section_foreground", sectionForeground);
		document.documentElement.style.setProperty("--header-background", headerBackground);
		document.documentElement.style.setProperty("--header-foreground", headerForeground);

		this.prevActiveInstance = activeInstance;
	}
}

document.addEventListener("DOMContentLoaded", () => {
	new ColorHandler();
	document.documentElement.classList.add("js", "ready");
});